<template>
  <section class="section home-news">
    <div class="section-inner">
      <div class="news-layout">
        <aside class="news-aside">
          <h2 class="section-title">保险信息</h2>
          <p class="section-subtitle">分享保险行业信息及各保险公司的产品信息</p>
          <button class="btn-primary" @click="goMore">查看更多</button>
        </aside>
        <div class="news-list">
          <article
            v-for="item in latestNews"
            :key="item.id"
            class="news-item"
            @click="goDetail(item.id)"
          >
            <div class="news-icon">
              <img v-if="item.icon" :src="item.icon" :alt="item.title">
              <span v-else class="news-icon-fallback" aria-hidden="true"></span>
            </div>
            <div class="news-main">
              <h3 class="news-title">{{ item.title }}</h3>
              <div class="news-meta">
                <span>{{ item.date }}</span>
                <span>· {{ item.author }}</span>
              </div>
              <p class="news-summary">{{ item.summary }}</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeNews',
  computed: {
    ...mapGetters(['getNewsList']),
    latestNews() {
      return (this.getNewsList || []).slice(0, 3)
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/news/${id}`).catch(() => {})
    },
    goMore() {
      this.$router.push('/news').catch(() => {})
    }
  }
}
</script>

<style scoped>
.home-news {
  background: #ffffff;
}

.news-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 36px;
  align-items: start;
}

.news-aside .section-subtitle {
  margin-bottom: 20px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.news-item {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid #dbe4f0;
  border-radius: 14px;
  background: #f8fbff;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.news-item:hover {
  border-color: #7dd3fc;
  box-shadow: 0 10px 24px rgba(2, 132, 199, 0.1);
  transform: translateY(-2px);
  background: #fff;
}

.news-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  overflow: hidden;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.news-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-icon-fallback {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(135deg, #7dd3fc, #0284c7);
}

.news-title {
  font-size: 17px;
  color: #1e293b;
  margin-bottom: 6px;
  font-weight: 700;
}

.news-meta {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 8px;
}

.news-summary {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .news-layout {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
